import { useEffect } from "react";
import { useAilaStore } from "./useAilaStore";
import useCurrentSession from "./useCurrentSession";
import useSessionStore from "./useSessionStore";

export const useAilaSessionSync = () => {
	const { currentItem } = useCurrentSession();
	const answers = useSessionStore((state) => state.answers);

	const updateItemId = useAilaStore((state) => state.updateItemId);
	const updateIsItemAnswered = useAilaStore(
		(state) => state.updateIsItemAnswered,
	);
	const updateSelectedQuery = useAilaStore(
		(state) => state.updateSelectedQuery,
	);
	const updateShowDrawer = useAilaStore((state) => state.updateShowDrawer);

	const currentItemId = currentItem?.id;
	const isAnswered = Boolean(
		currentItemId && (answers?.get(currentItemId) || currentItem?.answer),
	);

	useEffect(() => {
		if (!currentItemId || isAnswered) {
			return;
		}
		updateItemId(`${currentItemId}`);
		updateIsItemAnswered(false);
		updateSelectedQuery("");
		updateShowDrawer(false);
	}, [
		currentItemId,
		isAnswered,
		updateItemId,
		updateIsItemAnswered,
		updateSelectedQuery,
		updateShowDrawer,
	]);

	useEffect(() => {
		return () => {
			updateShowDrawer(false);
			updateSelectedQuery("");
		};
	}, [updateShowDrawer, updateSelectedQuery]);
};
